/**
 * Реферальная привязка на клиенте.
 *
 * Код-приглашение приходит либо в адресе PWA (`?ref=CODE`), либо в start_param
 * Telegram (`refCODE`). Ловим его при запуске и один раз пытаемся привязаться к
 * пригласившему. Начисление бонусов — на сервере, после первого расклада.
 */
import { tg } from './telegram'
import { api } from './api'

const CLAIMED_KEY = 'sirr_ref_claimed'

/** Реферальный код из адреса (PWA) или start_param (Telegram), или null. */
export function capturedRefCode(): string | null {
  try {
    const url = new URLSearchParams(window.location.search).get('ref')
    if (url) return url.trim().toLowerCase()
  } catch {
    /* нет доступа к адресу */
  }
  const sp = tg?.initDataUnsafe.start_param
  if (sp && sp.toLowerCase().startsWith('ref')) return sp.slice(3).trim().toLowerCase()
  return null
}

/** Один раз (на устройство) пытается привязаться к пригласившему. */
export async function claimReferralOnce(): Promise<void> {
  const code = capturedRefCode()
  if (!code || localStorage.getItem(CLAIMED_KEY)) return
  try {
    await api.claimReferral(code)
    // Ответ получен (в т.ч. «already/self/bad_code») — больше не пробуем.
    localStorage.setItem(CLAIMED_KEY, '1')
  } catch {
    // Сеть подвела — попробуем при следующем запуске.
  }
}

/** Ссылки-приглашения по коду: для браузера и для Telegram. */
export function inviteLinks(code: string): { pwa: string; telegram: string } {
  return {
    pwa: `https://sirr.app/?ref=${code}`,
    telegram: `https://t.me/Sirr_tarot_bot?startapp=ref${code}`,
  }
}

/**
 * Открывает «поделиться» ссылкой-приглашением. В Telegram — системный выбор
 * чата; в браузере — Web Share, иначе копирование в буфер. Возвращает, как
 * именно поделились, чтобы показать подсказку.
 */
export async function shareInvite(code: string, msg: string): Promise<'shared' | 'copied' | 'none'> {
  const links = inviteLinks(code)
  if (tg) {
    tg.openTelegramLink(
      `https://t.me/share/url?url=${encodeURIComponent(links.telegram)}&text=${encodeURIComponent(msg)}`,
    )
    return 'shared'
  }
  try {
    if (navigator.share) {
      await navigator.share({ title: 'SIRR', text: msg, url: links.pwa })
      return 'shared'
    }
  } catch {
    return 'none' // человек отменил
  }
  try {
    await navigator.clipboard.writeText(links.pwa)
    return 'copied'
  } catch {
    return 'none'
  }
}
